import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'sp-delete-set-variants-dialog',
    templateUrl: './delete-set-variants-dialog.component.html',
    styleUrls: ['./delete-set-variants-dialog.component.scss'],
})
export class DeleteSetVariantsDialogComponent implements OnInit {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        private data: any,
        private dialogRef: MatDialogRef<DeleteSetVariantsDialogComponent>
    ) {}

    ngOnInit(): void {}

    deleteVariant(): void {
      this.dialogRef.close(true);
    }
    cancelDeleteVariant(): void {
      this.dialogRef.close(false);
    }
}
